import { CircleDot } from 'lucide-react';
import type { HTMLAttributes, ReactNode } from 'react';

import {
  statusClass,
  statusIcon,
  statusLabel,
  type StatusState,
} from './statusSemantics';
import { cx } from './shared';

export interface BadgeProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  children?: ReactNode;
  state?: StatusState;
  tone?: 'neutral' | 'accent';
  size?: 'sm' | 'md';
}

const sizeClass = {
  sm: 'gap-1 px-2 py-0.5 text-meta',
  md: 'gap-1.5 px-2.5 py-1 text-control',
};

export default function Badge({
  children,
  state,
  tone = 'neutral',
  size = 'md',
  className,
  ...rest
}: BadgeProps) {
  const Icon = state ? statusIcon[state] : CircleDot;
  const toneClass =
    tone === 'accent'
      ? 'border-accent bg-accent-soft text-accent-ink'
      : 'border-status-neutral-border bg-status-neutral-surface text-status-neutral';

  return (
    <span
      data-so-status={state}
      className={cx(
        'inline-flex max-w-full items-center rounded-pill border font-semibold',
        state ? statusClass[state] : toneClass,
        sizeClass[size],
        className,
      )}
      {...rest}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{children ?? (state ? statusLabel[state] : null)}</span>
    </span>
  );
}
